/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import server from '../../_api/backend';
import { Pagenation } from '../../_component/pagenation';
import { FormatToComma } from '../../_component/format-to-comma';
import * as toast from '../../_store/slice/toast';

type Params = {
  keywords: string;
};

export function Search(routeProps: RouteComponentProps) {
  const dispatch = useDispatch();
  const [bookItems, setBookItems] = useState<any>([]);
  const { keywords } = routeProps.match.params as Params;
  const [
    pageInfo = { total: 10, rowCount: 25, page: 1, totalPages: 1 },
    setPageInfo,
  ] = useState<any>();

  useEffect(() => {
    getBooksList();
  }, [keywords]);

  // 도서 검색 키워드 결과 조회 API 호출
  const getBooksList = async () => {
    await server
      .searchMainBooks(1, 25, keywords)
      .then((payload) => {
        const { meta } = payload;
        setBookItems(payload.items);
        setPageInfo({
          total: meta.totalItems,
          rowCount: meta.itemsPerPage,
          page: meta.currentPage,
          totalPages: meta.totalPages,
        });
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // 아이템 pager 클릭 시
  const onClickPage = async (pageParam: any) => {
    if (pageInfo.totalPages !== 1) {
      await server
        .searchMainBooks(pageParam.page, 25, keywords)
        .then((payload) => {
          const { meta } = payload;
          setBookItems(payload.items);
          setPageInfo({
            total: meta.totalItems,
            rowCount: meta.itemsPerPage,
            page: meta.currentPage,
            totalPages: meta.totalPages,
          });
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
  };

  // Search 리턴값
  return (
    <main className="sub wrapper">
      <div className="content">
        <div className="breadscrumb">
          <>Home</>
          {' > '}
          <>도서검색</>
        </div>
        <div className="title">
          <h2>도서 검색 결과</h2>
          <p>입력하신 단어와 연관있는 도서명 또는 저자 목록입니다.</p>
        </div>
        <div className="items">
          {bookItems.map((book: any) => (
            <Link to={`/books/${String(book.id)}`} key={book.id}>
              <img src={`${process.env.REACT_APP_API_URL}/public${book?.imageMiddleUrl}`} />
              <ul>
                <li>{book?.name}</li>
                <li>{book?.author}</li>
                <li>{FormatToComma(book?.price)}원</li>
              </ul>
            </Link>
          ))}
        </div>
        {pageInfo && bookItems.length !== 0 ? (
          <Pagenation PageInfo={pageInfo} PagenationHandler={onClickPage} IsFirstEndArrow />
        ) : (
          <div className="table-footer">
            <div className="pagenation">
              <span>결과가 없습니다.</span>
            </div>
          </div>
        )}
      </div>
    </main>
  );
}
